import * as React from "react";
import { Grid } from "components/controls/widget";
import { hasFlag } from "components/state/types";
import { MemberApplication, MemberApplicationFormState } from "../entity";
import { MemberView } from "./member";
import { LegalRepresentativeView } from "./legalRepresentative";

interface Props {
    application: MemberApplication;
}

const View = ({ application }: Props) => {

    const showLegalRepresentative = hasFlag(application.formFlags, MemberApplicationFormState.HasLegalRepresentative);

    return <Grid container spacing={8}>
        <Grid item sm={12}>
            <MemberView application={application} />
        </Grid>

        {showLegalRepresentative && <Grid item sm={12}>
            <LegalRepresentativeView application={application} />
        </Grid>}

    </Grid>
}

export {
    View as ApplicationDetailComponent
}